import { ApiError, getLastRequestId } from "@/api/client"

export function ErrorState({
	error,
	message = "Oops, something went wrong.",
	className,
	messageClassName = "text-sm text-muted-foreground",
}: {
	error?: unknown
	message?: string
	className?: string
	messageClassName?: string
}) {
	const requestId =
		(error instanceof ApiError ? error.requestId : null) ?? getLastRequestId()

	return (
		<div
			className={`flex flex-col items-center justify-center gap-1 text-center ${className ?? ""}`}
		>
			<p className={messageClassName}>{message}</p>
			{requestId && (
				<p className="text-xs text-muted-foreground/70">
					Error ref: {requestId}
				</p>
			)}
		</div>
	)
}
